<template>
    <div class="main-container">
        <div class="filter-container">
            <el-select class="filter-item" v-model="currExportType" placeholder="预导出类型" style="width:150px">
                <el-option
                    v-for="(item, index) in exportType"
                    :key="index"
                    :label="item"
                    :value="item"
                ></el-option>
            </el-select>
            <el-button class="filter-btn" type="primary" @click="onDialogShow()">新增申请</el-button>
        </div>

        <el-table border :data="tableData">
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="admin_name" label="申请人"></el-table-column>
            <el-table-column prop="channel_no" label="渠道号"></el-table-column>
            <el-table-column prop="start_time" label="开始日期" width="120"></el-table-column>
            <el-table-column prop="end_time" label="结束日期" width="120"></el-table-column>
            <el-table-column prop="add_time" label="申请时间" width="170"></el-table-column>
            <el-table-column prop="achieve_time" label="完成时间" width="170"></el-table-column>
            <el-table-column label="状态">
                <template #default="scope">
                    <span v-if="scope.row.status == 0">生成中...</span>
                    <span v-if="scope.row.status == 1">已生成</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <div class="action-list">
                        <el-tag @click.prevent="onExport(scope.row.id)" v-if="scope.row.status == 1" size="small">导出</el-tag>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="`${currExportType}预导出申请`" v-model="dialogVisible" width="60%">
            <el-form label-width="120px">
                <el-form-item label="名称">
                    <el-input v-model="filters.name" placeholder="请输入名称" style="width:217px"></el-input>
                </el-form-item>
                
                <template v-if="exportFilters">
                    <el-form-item label="渠道">
                        <el-select v-model="filters.channel_no" filterable placeholder="请选择渠道">
                            <el-option
                                v-for="item in channelList"
                                :key="item.id"
                                :label="item.channel_name"
                                :value="item.channel_no">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="exportFilters.includes('日期区间')" label="日期类型">
                        <el-select class="filter-item" v-model="filters.date_status" placeholder="日期类型">
                            <el-option label="下单日期" :value="0"></el-option>
                            <el-option label="配送日期" :value="1"></el-option>
                            <el-option label="完成日期" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="exportFilters.includes('日期区间')" label="日期">
                        <el-date-picker v-model="filters.start_time" type="date" value-format="YYYY-MM-DD" placeholder="请选择开始日期"></el-date-picker>
                        --
                        <el-date-picker v-model="filters.end_time" type="date" value-format="YYYY-MM-DD" placeholder="请选择结束日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item v-if="exportFilters.includes('订单状态')" label="订单状态">
                        <el-select class="filter-item" v-model="filters.type" placeholder="订单状态">
                            <el-option label="全部" :value="0"></el-option>
                            <el-option label="待确认" :value="1"></el-option>
                            <el-option label="已确认" :value="2"></el-option>
                            <el-option label="已完成" :value="3"></el-option>
                            <el-option label="已取消" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="exportFilters.includes('品牌')" label="品牌">
                        <el-select v-model="filters.brand_ids" filterable placeholder="请选择品牌">
                            <el-option
                                v-for="item in brandList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>

                <el-form-item style="text-align:right">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="onAddApply()">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import { defineComponent, getCurrentInstance, toRefs, reactive, watch, computed } from 'vue'
import Keys from '@/constant/key'
import { roleExportTypes, exportTypeFilters, Branches } from './constant'
import { joinParams } from '@/utils'
export default defineComponent({
name: 'Finance',
setup() {
    const { proxy } = getCurrentInstance()
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const data = reactive({
        role: route.fullPath.split('/')[2],
        currExportType: '',
        exportFilters: [],
        exportTarget: '',
        filters: {
            admin_name: store.state.user.userInfo.username,
            name: '',
            channel_no: '',
            type: 0,
            date_status: 0,
            start_time: '',
            end_time: '',
            brand_ids: '',
            target: '',
            branch_id: Branches[route.fullPath.split('/')[2]]
        },
        tableData:   [],     // 预导出列表数据
        dialogVisible:  false,  // 申请弹框
        channelList:    [],     // 渠道列表
        brandList:      [],     // 品牌列表
        name:           '',     // 预导出申请名称
        startDate:      '',     // 导出开始时间
        endDate:        '',     // 导出结束时间
        channelNo:      '',     // 当前选中渠道
        maxDate:        new Date(), // 最大可选日期

        // 显示添加一条申请弹框
        onDialogShow () {
            if (!data.currExportType) {
                return proxy.$message({
                    type: 'error',
                    message: '请选择导出类型'
                })
            }
            exportFilters.value.includes('渠道') && data.getChannelList() // 包含渠道参数获取渠道列表
            exportFilters.value.includes('品牌') && data.getBrandList() // 包含品牌参数获取品牌列表
            data.dialogVisible = true
        },
        // 添加一条申请
        async onAddApply () {
            let { filters } = data
            filters.target = exportTarget
            const res = await proxy.$http.post('/channel/report_apply_for', filters)
            const { code, msg } = res
            if (code == 200) {
                proxy.$message({
                    type: 'success',
                    message: '申请成功'
                })
                data.getPreList()
                data.dialogVisible = false
            } else {
                proxy.$message({
                    type: 'error',
                    message: msg
                })
            }
        },
        // 获取预导出申请列表数据
        async getPreList () {
            const { branch_id } = data.filters
            const target = exportTarget.value
            const res = await proxy.$http.get(`/channel/report_apply_for_list?${joinParams({ branch_id, target })}`)
            const { code, data:resData, msg} = res
            if (code == 200) {
                data.tableData = resData
            } else {
                proxy.$message({
                    type: 'error',
                    message: msg
                })
            }
        },
        // 获取渠道列表
        getChannelList: () => {
            proxy.$http.get(`/dsapi/trade/channel_info`).then((res ) => {
                if(res.code == 200){
                    data.channelList = res.data;
                }else{
                    proxy.$message({type:'error',message:res.msg});
                }
            })
        },
        // 获取品牌列表
        getBrandList: () => {
            proxy.$http.get(`/dsapi/trade/brands_list`).then(res => {
                if (res.code != 200) return proxy.$message({
                    type: 'error',
                    message: res.msg
                })
                data.brandList = res.data
            })
        },
        // 结算订单导出
        onExport (applyId) {
            window.open(`${Keys.baseUrl}/channel/report_apply_for_download?id=${applyId}`)
        }
    })
    const exportType = computed(() => roleExportTypes[data.role]) // 当前角色可导出数据列表
    const exportFilters = computed(() => exportTypeFilters[data.currExportType]?.filters) // 当前导出数据包含的可选字段
    const exportTarget = computed(() => exportTypeFilters[data.currExportType]?.target) // 当前导出数据导出时传递类型
    watch(() => router.currentRoute.value.path, (newValue, oldValue) => {
        data.role = newValue.split('/')[2]
        data.currExportType = ''
        data.tableData = []
        data.filters.branch_id = Branches[newValue.split('/')[2]]
    })
    watch(() => data.currExportType, (newValue, oldValue) => {
        newValue && data.getPreList()
    })
    return { ...toRefs(data), exportType, exportFilters, exportTarget }
}
})
</script>